export default __webpack_public_path__ + "static/media/Gabriel_Rosenberg_square.9f7f8202.jpg";